<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle"><span class="l-pageLabel">監査</span>監査の新規作成</h1>
      <div class="l-contentsBox">
        <div class="u-mb40">
          <h2 class="l-formGroup__label">法人名</h2>
          <div class="l-company__select select" @click="showCorporateList(true)">
            <span>{{ !corpName ? '法人を選択' : corpName }}</span>
          </div>

        </div>
        <div class="u-mb40">
          <h2 class="l-formGroup__label">コース選択</h2>
          <div class="l-course-select">
            <div class="l-course-select__main">
              <h3 class="l-headding is-blue">診断コースを選んでください。</h3>
              <div class="l-course-select__items" >
                <div class="l-course-select__item" v-show="showPlan(diagCourse.isDisplayPricePlan2, diagCourse.isDisplayPricePlan3)" v-for="diagCourse in this.standardDiagCourseList" :key="diagCourse.diagCourseId">
                    <div class="l-course-select__item-header" >
                        <input type="radio" name="course" :id="diagCourse.diagCourseId" :value="diagCourse.diagCourseId" v-model="$v.diagCourseId.$model">
                        <label :for="diagCourse.diagCourseId">
                        <b>{{ diagCourse.courseName }}</b>
                        </label>
                    </div>
                    <div class="l-course-select__item-body" >
                        <div class="label">{{ diagCourse.questionCountText }}</div>
                        <p>{{ diagCourse.description }}</p>
                    </div>
                </div>

                    <a href="https://ad-sdgs.com/entries" class="l-course-select__item is-link " target="_blank" v-show="showPlan(false, true)">
                        <div class="l-course-select__item-header">SDGs経営簡易診断</div>
                        <div class="l-course-select__item-body">
                            <p>本サービスはあいおいニッセイ同和損害保険（株）の代理店のみ利用可能です。</p>
                            <p class="link-btn is-blank" ><span>診断する</span></p>
                        </div>
                    </a>
                    <a href="" @click="goRoughDiagAnswer(14)" class="l-course-select__item is-link" v-show="showPlan(false, true)">
                        <div class="l-course-select__item-header">健康経営版</div>
                        <div class="l-course-select__item-body">
                            <p>健康経営取組みにおける一般的な対応状況をチェックすることができます。 本サービスはあいおいニッセイ同和損害保険（株）の代理店のみ利用可能です。</p>
                            <p class="link-btn"><span>診断する</span></p>
                        </div>
                    </a>

              </div>

            </div>
          </div>
          <div class="l-course-select">
            <div class="l-course-select__option">
              <h3 class="l-headding is-small is-blue">オプション監査の利用には別途お申し込みが必要です。ご利用を希望される場合はお問い合わせください。</h3>
              <div class="l-course-select__items">
                <div class="l-course-select__item" :class="{ 'is-disable' : !diagCourse.isAvailable }" v-show="showPlan(diagCourse.isDisplayPricePlan2, diagCourse.isDisplayPricePlan3)" v-for="diagCourse in this.optionDiagCourseList" :key="diagCourse.diagCourseId">
                    <div class="l-course-select__item-header">
                        <input type="radio" name="course" :id="diagCourse.diagCourseId" :value="diagCourse.diagCourseId" v-model="$v.diagCourseId.$model">
                        <label :for="diagCourse.diagCourseId"><b>{{ diagCourse.courseName }}</b><small>オプション監査</small></label>
                    </div>
                    <div class="l-course-select__item-body">
                        <div class="label">{{ diagCourse.questionCountText }}</div>
                        <p>{{ diagCourse.description }}</p>
                    </div>
                </div>

              </div>

            </div>
          </div>

        </div>



        <div class="btn-group">
          <div class="btn-basic is-inlne is-primary" @click="start()" :disabled="isProcessing">
            <a>監査を新規作成</a>
          </div>
        </div>
      </div>
    </div>
    <transition name="corplist-fade">
      <CorporateListModal
        v-show="isShowCorporateList"
        @hide-corporate-list-modal="showCorporateList(false)"
        @select-corporate="emitSelectCorpList"
      ></CorporateListModal>
    </transition>

  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import { required } from 'vuelidate/lib/validators';
import CorporateListModal from '@/components/pages/corporate/CorporateListModal.vue';

export default {
  components: {
    Loading,
    CorporateListModal,
  },
  data() {
    return {
      planName: '',
      isShowCorporateList: false,
      isProcessing: false,
      diagCourseId: null,
      diagCourseList: [],
      standardDiagCourseList: [],
      optionDiagCourseList: [],
      corpList: [],
    }
  },
  computed: {
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    corpName() {
      return this.$store.getters['diag/getCorpName'];
    },
  },
  watch: {
  },
  created: function () {
    this.planName =  this.$store.getters['auth/getUser'].planName;

    this.getDiagCourseList();
  },
  validations: {
    diagCourseId: { required },
  },
  methods: {
    showPlan(dispPlan2, dispPlan3){
        if(dispPlan2&&this.planName=='社労士'){
            return true;
        }
        if(dispPlan3&&this.planName=='代理店'){
            return true;
        }
        return false;
    },
    goRoughDiagAnswer(roughDiagId) {
      this.$store.dispatch('diag/setRoughDiagId', roughDiagId);
      this.$router.push({ name: 'rough-diag-answer', query: { roughDiagId: roughDiagId } });
    },
    async emitSelectCorpList(params) {

      this.isProcessing = false;
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);

      await this.$refs.latestDiagResult.getLatestDiagResultForCorporate(params.corpId, null);
      await this.$refs.roughDiagResultList.getRoughDiagResultHistory(params.corpId);

      this.$nextTick(() => {
        this.isProcessing = false;
      });
    },
    async getDiagCourseList() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/diag/getDiagCourseList', {
        corpId: this.corpId
      });
      if (res) {
        this.diagCourseList = res.data.diagCourseList;
        this.standardDiagCourseList = res.data.standardDiagCourseList;
        this.optionDiagCourseList = res.data.optionDiagCourseList;
      }
      this.isProcessing = false;
    },
    showCorporateList(value) {
      this.isShowCorporateList = value;
    },
    start() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('diag/setDiagResultId', null);
        this.$store.dispatch('diag/setDiagCourseId', this.diagCourseId);
        this.$store.dispatch('diag/initEachSearchForm');

        let diagCourse = this.diagCourseList.find(dc => dc.diagCourseId === this.diagCourseId);
        this.$store.dispatch('diag/setIsOptionDiag', diagCourse.isOptionDiag);
        this.$store.dispatch('diag/setSectionNotUseFlag', diagCourse.sectionNotUseFlag);
        if (!diagCourse.sectionNotUseFlag) {
          this.$router.push({ name: 'diag-section-list', query: { diagCourseId: this.diagCourseId } });
        } else {
          this.$router.push({ name: 'option-diag-answer-input', query: { diagCourseId: this.diagCourseId } });
        }
      }
    },
  }
}

</script>

<style scoped>
.inline {
  display: inline;
}
.select {
  width: 300px;
}

.corplist-fade-enter-active {
  transition: all .2s ease;
}
.corplist-fade-leave-active {
  transition: all .2s ease;
}
.corplist-fade-enter {
  transform: translateY(-50px);
  opacity: 0;
}
.corplist-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
